import { IconButton, Icons, Tooltip } from '@healthinal/ui';
import { IBezugspersonWithPerson } from '../../../../../api/generated/bezugperson-controller/bezugperson-controller';
import { TruncateText } from '../../../../../components/TruncateText';
import { getSalutationName } from '../../../../../utils/salutation.ts';

type Props = {
  item: IBezugspersonWithPerson;
  onShowHistory?: (item: IBezugspersonWithPerson) => void;
};

function formatPersonName(person: IBezugspersonWithPerson['person']) {
  const name = [person.firstName, person.lastName].filter(Boolean).join(' ').trim();
  return name || '-';
}

export function ReferencePersonTableRow({ item, onShowHistory }: Props) {
  return (
    <>
      <td>
        <TruncateText>{getSalutationName(item.salutation)}</TruncateText>
      </td>
      <td>
        <TruncateText>{item.lastName ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{item.firstName ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{item.position ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{item.phoneNumber ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{item.email ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{formatPersonName(item.person)}</TruncateText>
      </td>
      <td onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <Tooltip title="Verlauf">
          <IconButton
            size="sm"
            variant="plain"
            color="neutral"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onShowHistory?.(item);
            }}>
            <Icons.History />
          </IconButton>
        </Tooltip>
      </td>
    </>
  );
}
